import { createFileRoute, redirect } from '@tanstack/react-router';

import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/audit/evidence/')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.auditEvidence'),
  }),
  loader: () => {
    throw redirect({ to: '/evidence/repository', replace: true });
  },
});
